export const RWA_SHARED_ERC20_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "name_",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "symbol_",
        "type": "string"
      },
      {
        "internalType": "address[]",
        "name": "initialMinters",
        "type": "address[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Approval",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "MinterUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "Transfer",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "allowance",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "spender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "approve",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "decimals",
    "outputs": [
      {
        "internalType": "uint8",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "minters",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "allowed",
        "type": "bool"
      }
    ],
    "name": "setMinter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transfer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "transferFrom",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

export const RWA_SHARED_ERC20_BYTECODE = "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";

export const RWA_SHARED_ERC20_SOLIDITY_SOURCE = "// SPDX-License-Identifier: MIT\npragma solidity ^0.8.19;\n\n/**\n * @title RwaSharedErc20\n * @notice Minimal CBC20-style fungible token for catalog deployment: fixed 18 decimals,\n *         owner + `minters` who may `mint` and `burn` their own balance. Same operator\n *         model as RwaSharedSeriesErc721 for platform suspend/approve alignment.\n *         Not a full security-audited ERC-20 stack — extend for production (pausing, roles, etc.).\n */\ncontract RwaSharedErc20 {\n    string public name;\n    string public symbol;\n    uint8 public constant decimals = 18;\n    uint256 public totalSupply;\n    address public owner;\n\n    mapping(address => uint256) public balanceOf;\n    mapping(address => mapping(address => uint256)) public allowance;\n    mapping(address => bool) public minters;\n\n    event Transfer(address indexed from, address indexed to, uint256 value);\n    event Approval(address indexed owner, address indexed spender, uint256 value);\n    event MinterUpdated(address indexed account, bool allowed);\n\n    modifier onlyOwner() {\n        require(msg.sender == owner, \"Only owner\");\n        _;\n    }\n\n    constructor(string memory name_, string memory symbol_, address[] memory initialMinters) {\n        owner = msg.sender;\n        name = name_;\n        symbol = symbol_;\n        for (uint256 i = 0; i < initialMinters.length; i++) {\n            address a = initialMinters[i];\n            if (a != address(0)) {\n                minters[a] = true;\n                emit MinterUpdated(a, true);\n            }\n        }\n    }\n\n    function setMinter(address account, bool allowed) external onlyOwner {\n        require(account != address(0), \"Zero minter\");\n        minters[account] = allowed;\n        emit MinterUpdated(account, allowed);\n    }\n\n    function approve(address spender, uint256 amount) external returns (bool) {\n        allowance[msg.sender][spender] = amount;\n        emit Approval(msg.sender, spender, amount);\n        return true;\n    }\n\n    function transfer(address to, uint256 amount) external returns (bool) {\n        _transfer(msg.sender, to, amount);\n        return true;\n    }\n\n    function transferFrom(address from, address to, uint256 amount) external returns (bool) {\n        uint256 a = allowance[from][msg.sender];\n        require(a >= amount, \"Allowance\");\n        allowance[from][msg.sender] = a - amount;\n        _transfer(from, to, amount);\n        return true;\n    }\n\n    function mint(address to, uint256 amount) external {\n        require(msg.sender == owner || minters[msg.sender], \"Not minter\");\n        require(to != address(0), \"Zero to\");\n        totalSupply += amount;\n        balanceOf[to] += amount;\n        emit Transfer(address(0), to, amount);\n    }\n\n    /// @notice Burns from `msg.sender` balance (operator burns their own held inventory).\n    function burn(uint256 amount) external {\n        require(msg.sender == owner || minters[msg.sender], \"Not minter\");\n        require(balanceOf[msg.sender] >= amount, \"Balance\");\n        balanceOf[msg.sender] -= amount;\n        totalSupply -= amount;\n        emit Transfer(msg.sender, address(0), amount);\n    }\n\n    function _transfer(address from, address to, uint256 amount) internal {\n        require(to != address(0), \"Zero to\");\n        require(balanceOf[from] >= amount, \"Balance\");\n        balanceOf[from] -= amount;\n        balanceOf[to] += amount;\n        emit Transfer(from, to, amount);\n    }\n}\n";

export const RWA_SHARED_ERC20 = {
  contractName: "RwaSharedErc20",
  abi: RWA_SHARED_ERC20_ABI,
  abiJson: JSON.stringify(RWA_SHARED_ERC20_ABI),
  bytecode: RWA_SHARED_ERC20_BYTECODE,
  mintFunctionName: "mint",
  soliditySource: RWA_SHARED_ERC20_SOLIDITY_SOURCE,
  sourceFileName: "RwaSharedErc20.sol"
};
